import React, { useEffect, useState } from 'react';
import './LogoCarousel.css';

const LogoCarousel = () => {
  const [isMobile, setIsMobile] = useState(false);

  const logos = [
    { src: "/collaboratorLogo1.png", alt: "Placeholder Logo 1" },
    { src: "/collaboratorLogo3.png", alt: "Placeholder Logo 2" },
    { src: "/collaboratorLogo2.png", alt: "Placeholder Logo 3" },
    { src: "/collaboratorLogo4.png", alt: "Placeholder Logo 4" },
    { src: "/collaboratorLogo6.png", alt: "Placeholder Logo 6" },
    { src: "/collaboratorLogo5.png", alt: "Placeholder Logo 5" }
  ];

  // Check if mobile on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div className="logo-carousel-container">
      {isMobile && <h3 className="carousel-title mobile-title">Founders' Experience</h3>}
      {isMobile ? (
        <div className="logo-carousel-mobile">
          {logos.map((logo, index) => (
            <img 
              key={index} 
              src={logo.src} 
              alt={logo.alt} 
              className="carousel-logo" 
            />
          ))}
        </div>
      ) : (
        <div className="logo-carousel">
          <img src="/collaboratorLogo1.png" alt="Placeholder Logo 1" className="carousel-logo" />
          <img src="/collaboratorLogo3.png" alt="Placeholder Logo 2" className="carousel-logo" />
          <img src="/collaboratorLogo2.png" alt="Placeholder Logo 3" className="carousel-logo" />
          <h3 className="carousel-title">Founders'<br />Experience</h3>
          <img src="/collaboratorLogo4.png" alt="Placeholder Logo 4" className="carousel-logo" />
          <img src="/collaboratorLogo6.png" alt="Placeholder Logo 6" className="carousel-logo" />
          <img src="/collaboratorLogo5.png" alt="Placeholder Logo 5" className="carousel-logo" />
        </div>
      )}
    </div>
  );
};

export default LogoCarousel; 